module.exports = __webpack_public_path__ + "img/ChemistryLogo.733cfce5.svg";